export function timeDurationToReadableForm(time) {
  // let startDate = new Date(startTime);
  // let endDate = new Date(endTime);
  let diffMs = (time * 60 * 1000); // milliseconds between now & Christmas
  let diffDays = Math.floor(diffMs / 86400000); // days
  let diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
  let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
  if (diffDays === 0) {
    if (diffHrs === 0) {
      return (diffMins + ' minutes');
    }
    return (diffHrs + ' hours, ' + diffMins + ' minutes');
  }
  return (diffDays + ' days, ' + diffHrs + ' hours, ' + diffMins + ' minutes');
}

export function isEmpty(obj) {
  for (const prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      return false;
    }
  }

  return JSON.stringify(obj) === JSON.stringify({});
}
